import Dropzone from 'dropzone';
import Modal from './_bootstrapModalExtensions';

Dropzone.autoDiscover = false;

// The filetypes allowed when uploading files for a process pr process action
var defaultAcceptedFileTypes = "text/plain,image/jpeg,application/pdf,.ifc";
var defaultMaxFileSize = 30;

let initialized: boolean = false;

export type DropzoneQueueCompletedCallback = () => void;

export function initUploadDropZone(url: string | null, onQueueComplete: DropzoneQueueCompletedCallback |null) : Dropzone {
    if (initialized) {
        return;
    }

    var dropzoneElement = $('#uploadDocumentForProcess');

    // Nothing to initialize
    if (dropzoneElement.length === 0) {
        return;
    }

    // When initializing DZ on a multi-tabbed page, the upload details are stored in data- properties (which are not in the dom yet)
    // The DZ element is already in the dom, but can't be initialized as such (no target can be found (de default value of target is not good either))
    var action = dropzoneElement.prop('action');
    if (!url && (!action || action === '' || action === location.href)) {
        return;
    }

    var acceptedFileTypes = dropzoneElement.data('acceptedfiletypes') || defaultAcceptedFileTypes;

    if (acceptedFileTypes === '*/*') {
        acceptedFileTypes = undefined;
    }

    var maxFileSize = dropzoneElement.data('maxfilesize') || defaultMaxFileSize;

    if (dropzoneElement.length > 0) {
        let dropzoneObject = new Dropzone('#uploadDocumentForProcess', {
            dictDefaultMessage: 'Kattintson, vagy húzza ide a kiválasztott fájlokat',
            dictFallbackMessage: "Az Ön böngészője nem támogatja a 'fogd és vidd' művelettel történő fájl feltöltést.",
            dictFallbackText: "A fájlok feltöltéséhez kérjük, használja az alábbi módszert.",
            dictFileTooBig: "Túl nagy fájl. Maximálisan feltölthető méret: " + maxFileSize + "MB.",
            dictInvalidFileType: "Nem tölthet fel ilyen típusú fájlokat.",
            dictResponseError: "A kiszolgáló a {{statusCode}} kóddal válaszolt.",
            dictCancelUpload: "Feltöltés megszakítása",
            dictCancelUploadConfirmation: "Biztos benne, hogy megszakítja ezt a feltöltést?",
            dictRemoveFile: "Fájl eltávolítása",
            dictMaxFilesExceeded: "Nem tud több fájlt feltölteni.",
            paramName: "file",
            maxFilesize: maxFileSize, // MB
            acceptedFiles: acceptedFileTypes,
            uploadMultiple: false,
            parallelUploads: 4,
            url: url,
            previewsContainer: '#dz-previews',
            previewTemplate: '<div class="dz-preview">' +
                '<div class="dz-preview-container">' +
                '<span data-dz-name class="dz-file-name"></span>' +
                '<div class="dz-progress">' +
                '<div class="dz-progress-bar"><span data-dz-uploadprogress style="width: 0%;"></span></div>' +
                '<span class="dz-progress-text">0</span>' +
                '</div>' +
                '<span class="dz-error-message" data-dz-errormessage></span>' +
                '</div>' +
                '</div>',

            init: function () {
                this.on('uploadprogress', function (f, p) {
                    p = Math.round(p);
                    if (p === 100) {
                        p = 99;
                    }
                    $(f.previewElement).find('.dz-progress-text').text(p);
                });
            },
            error: function (file, response, xhr) {
                var message = '';
                if ($.type(response) === "string") {
                    // dropzone sends it's own error messages in string
                    message = response;
                }
                else {
                    message = response.message;
                }

                file.previewElement.classList.add("dz-error");
                let _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
                let _results = [];

                for (let _i = 0, _len = _ref.length; _i < _len; _i++) {
                    let node = _ref[_i];
                    _results.push(node.textContent = message);
                }
                return _results;
            },
            success: function (event) {
                $(event.previewElement).find('.dz-progress-text').text(100);
                $(event.previewElement).addClass('dz-success');
                $(event.previewElement).removeClass('dz-processing');

                let newUploadCount = parseInt($('#dz-upload-count .upload-counter').html()) + 1;
                $('#dz-upload-count .upload-counter').html(newUploadCount.toString());

                setTimeout(function () {
                    $(event.previewElement).slideUp(function () {
                        $(this).remove();
                    });

                    Modal.closeUploadModal();
                }, 2000);
            },
            queuecomplete: function () {
                this.files.forEach(function (file) {
                    if (file.status !== 'success') {
                        $('#retry-upload').removeClass('button__disabled');
                        return;
                    }
                });

                var func = onQueueComplete || dropzoneElement.data('onqueuecomplete');
                if (func) {
                    eval(func);
                }
            }
        });

        initialized = true;

        return dropzoneObject;
    }
}

$(() => {
    $('body').on('click', '.dropzone-showdialog', () => {
        var modal = $('#generic-modal-upload');

        modal.off('show.bs.modal').on('show.bs.modal', () => {

            var showDropzoneModalButton = $('.dropzone-showdialog');

            var url = showDropzoneModalButton.data('url');
            var onQueueComplete = showDropzoneModalButton.data('on-queue-complete');

            initUploadDropZone(url, onQueueComplete);
        });

        modal.modal();
    });

    // If the upload stuff is not in a popup window (mainly green side), then the form is not yet initialized. Initialize it.
    let dropzoneObject = initUploadDropZone(null, null);

    $('body').on('click', '#retry-upload', () => {
        $(this).addClass('button__disabled');

        if (containsError(dropzoneObject.files)) {
            for (var i = 0; i < dropzoneObject.files.length; i++) {
                var file = dropzoneObject.files[i];

                if (file.status !== 'success' && file.accepted) {
                    $(file.previewElement).removeClass('dz-error');
                    $(file.previewElement).removeClass('dz-complete');
                    $(file.previewElement).find('.dz-progress-text').text('0');
                    $(file.previewElement).find('.dz-progress-bar span').css('width', '0%');
                    $(file.previewElement).find('.dz-error-message').text('');

                    file.status = Dropzone.QUEUED;
                    file.upload.progress = 0;
                    file.upload.bytesSent = 0;
                }
            }

            dropzoneObject.processQueue();

            if (dropzoneObject.getRejectedFiles().length > 0) {
                $('#retry-upload').removeClass('button__disabled');
            }
        }
    });

    function containsError(files) {
        if (!(files instanceof Array)) {
            return false;
        }

        for (var i = 0; i < files.length; i++) {
            if (files[i].status !== 'success') return true;
        }

        return false;
    }
});
